module.exports = __webpack_public_path__ + "static/img/erweima.e0dc3bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.png
// module id = hMRt
// module chunks = 18